import { Button, Stack, Typography } from "@mui/material";
import useCheckoutStore from "../../../../../stores/public/useCheckoutStore";
import ReservationSummary from "./components/ReservationSummary";
import { useState } from "react";
import OrderCreditCardCheckout from "../../../orders/OrderCreditCardCheckout";

export default function Checkout({previousStep}) {
  const [checkingOut, setCheckingOut] = useState(false);

  const { storePage, reservation } = useCheckoutStore();

  return (
    <Stack>
      <Stack gap={2} mb={2}>
        <Stack>
          <Typography variant="h4">Checkout</Typography>
        </Stack>
        <Stack>
          <ReservationSummary reservation={reservation} />
        </Stack>
      </Stack>
      {checkingOut ?
      <Stack>
        <OrderCreditCardCheckout order={reservation.order} returnUrl={`http://ims.wush.life/stores/${storePage.uuid}/confirmation/${reservation.order.id}`} />
      </Stack>
      :
      <Stack width="100%" justifyContent="center" px={"25%"}>
        <Button variant="contained" onClick={() => setCheckingOut(true)}>Checkout</Button>
      </Stack>}
      <Stack direction={"row"} width={"100%"} justifyContent={"left"}>
      <Button onClick={previousStep}>Back</Button>
      </Stack>
    </Stack>
  );
}